import { getFirstLine } from "../aplUtils/stringUtills";
import { bootboxAlert } from "../components/common/bootboxWrapper";

async function tryCatchBootbox<Type>(func: () => Type) {
    try {
        let result = await func();
        return result;
    } catch (err: any) {
        if (err?.response?.data?.title) bootboxAlert(err?.response?.data?.detail, () => {});
        else if (err?.response?.data?.detail) bootboxAlert(err?.response?.data?.detail, () => {});
        else if (err?.response?.data?.exceptionMessage) bootboxAlert(err.response.data.exceptionMessage, () => {});
        else if (err?.response?.data) bootboxAlert(getFirstLine(err.response.data), () => {});
        else bootboxAlert(err.message, () => {});
    }
}

async function tryCatchContinueBootbox<T, D>(func1: () => T, func2: () => D) {
    try {
        await func1();
        return await func2();
    } catch (err: any) {
        if (err?.response?.data?.title) bootboxAlert(err?.response?.data?.detail, () => {});
        else if (err?.response?.data?.detail) bootboxAlert(err?.response?.data?.detail, () => {});
        else if (err?.response?.data?.exceptionMessage) bootboxAlert(err.response.data.exceptionMessage, () => {});
        else if (err?.response?.data) bootboxAlert(getFirstLine(err.response.data), () => {});
        else bootboxAlert(err.message, () => {});
    }
}

export { tryCatchBootbox, tryCatchContinueBootbox }
